import { ProfileDetailsType } from "./ProfileDetailsType"

export type ContactInfoType = Pick<ProfileDetailsType,
  "tradeName" |
  "firstName" |
  "lastName" |
  "contactName" |
  "contactPosition" |
  "phoneNumber" |
  "phoneExtension" |
  "secondaryPhoneNumber" |
  "secondaryPhoneExtension" |
  "email" |
  "agentFlag">

export const initialContactInfo: ContactInfoType = {
  tradeName: null,
  firstName: null,
  lastName: null,
  contactName: null,
  contactPosition: null,
  phoneNumber: null,
  phoneExtension: null,
  secondaryPhoneNumber: null,
  secondaryPhoneExtension: null,
  email: null,
  agentFlag: null
}

export const keysOfContactInfoType: (keyof ContactInfoType)[] = [
  "tradeName",
  "firstName",
  "lastName",
  "contactName",
  "contactPosition",
  "phoneNumber",
  "phoneExtension",
  "secondaryPhoneNumber",
  "secondaryPhoneExtension",
  "email",
  "agentFlag"
];